import { Col, DatePicker, Input, Row } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { HelpMessage } from 'utils/constants'
import { useDesignSubmittalLogContext } from '../../../../../../../DesignSubmittalLogContext'
import { SharePointRegexValidation } from 'shared'
import { DetailsBodyProps } from './types'
const help = HelpMessage.DesignSubmittals.Log

const DetailsBody: React.FC<DetailsBodyProps> = ({
  typesOptions,
  orgsOptions,
}) => {
  const { allPackageNumbers } = useDesignSubmittalLogContext()
  const { invalidChars, whitespace } = SharePointRegexValidation
  return (
    <>
      <Row gutter={30}>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="packageNumber"
            label="Package Number"
            requiredMessage="Please enter a package number"
            invalid={[
              {
                testPattern: invalidChars.regex,
                message: invalidChars.message,
              },
              {
                testPattern: whitespace.regex,
                message: whitespace.message,
              },
            ]}
            customValidator={{
              validator: (packageNumber) =>
                !allPackageNumbers.includes(packageNumber),
              message: 'Package Number already in use',
            }}
            validateFirst="parallel"
            help={help.PackageNumber}
          >
            <Input allowClear />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="packageName"
            label="Package Name"
            requiredMessage="Please enter a package name"
            invalid={[
              {
                testPattern: invalidChars.regex,
                message: invalidChars.message,
              },
              {
                testPattern: whitespace.regex,
                message: whitespace.message,
              },
            ]}
            validateFirst="parallel"
            help={help.PackageName}
          >
            <Input allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="typeId"
            label="Type"
            requiredMessage="Please select a type"
            help={help.Type}
          >
            <CIMSSelect simple options={typesOptions} />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="organizationId"
            label="Submitting Organization"
            requiredMessage="Please select and organization"
            help={help.SubmittingOrg}
          >
            <CIMSSelect simple options={orgsOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="requestedActionDate"
            label="Requested Action Date"
            requiredMessage="Please enter a requested action date"
            help={help.RequestedActionDate}
          >
            <DatePicker allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
    </>
  )
}

export default DetailsBody
